/** Cart domain constants. Previously in shared/constants/cartConstants.js */

export const CART_STATE_ACTIVE = 'Active';

/**
 * LEGACY FALLBACK: Mapping from delegateRate to customer group IDs.
 * Prefer using item.variant.prices directly when available.
 * TODO: Remove once all data migrated to proper customer group references.
 */
export const DELEGATE_RATE_TO_CUSTOMER_GROUP: Record<string, string> = {
  'Standard Rate': 'b1a19a47-4068-43c0-85c7-878d388b4534',
  'Large Fund Rate': '3dce5af2-83c5-4cd5-9378-94c33f313eaa',
  'Emerging Fund Rate': '2322b3dc-3bf1-4533-9139-c0ae7c301f81',
};

/** Default customer group ID for Standard Rate (fallback). */
export const DEFAULT_CUSTOMER_GROUP_ID = 'b1a19a47-4068-43c0-85c7-878d388b4534';

/**
 * Hardcoded eligibility confirmation text for delegate rates that require user consent.
 * Standard Rate requires no confirmation. All other rates use this text as a fallback
 * until the rateConfirmation field is populated in the CT customer group custom type.
 */
export const DELEGATE_RATE_CONFIRMATION_TEXT: Record<string, string> = {
  'Large Fund Rate': "I confirm that I'm eligible for this delegate type and can provide proof of eligibility.",
  'Emerging Fund Rate': "I confirm that I'm eligible for this delegate type and can provide proof of eligibility.",
};

export const DEFAULT_PROMO_LABEL = 'Promo';
